import angular from 'angular';

(function() {
  'use strict';
  angular.module('app.core').factory('UsersFilter', UsersFilterData);

  UsersFilterData.$inject = ['KISS_USER', 'PrincipalDetail'];

  /* @ngInject */
  function UsersFilterData(KISS_USER, PrincipalDetail) {
    User.prototype = {
      build: build,
      buildEmpty: buildEmpty,
      preparBeforeSearch: preparBeforeSearch,
      setPage: setPage,
      setPageSize: setPageSize,
      setSort: setSort,
      resetSort: resetSort
    };

    function User(usersFilterData) {
      if (!usersFilterData) {
        this.buildEmpty();
      } else {
        this.build(usersFilterData);
      }
    }

    return User;

    /////////////////////

    function buildEmpty() {
      this.sellerId = null;
      this.principalId = null;
      this.userName = null;
      this.login = null;
      this.email = null;
      this.role = 'ALL';
      this.status = 'ALL';
      this.pageCriteria = {
        pageSize: KISS_USER.pagination.defaultPageSize,
        page: KISS_USER.pagination.defaultPage,
        sorts: KISS_USER.pagination.defaultSort
      };
    }

    function build(usersFilterData) {
      this.sellerId = usersFilterData.sellerId || null;
      this.principalId = usersFilterData.principalId || null;
      this.userName = usersFilterData.userName || null;
      this.login = usersFilterData.login || null;
      this.email = usersFilterData.email || null;
      this.role = usersFilterData.role || 'ALL';
      this.status = usersFilterData.status || 'ALL';
      this.legalEntityGroupId = usersFilterData.legalEntityGroupId || null;
      this.pageCriteria = {
        pageSize: usersFilterData.pageSize || KISS_USER.pagination.defaultPageSize,
        page: usersFilterData.page || KISS_USER.pagination.defaultPage,
        sorts: _setSort(usersFilterData.sorts)
      };
    }

    function _setSort(sorts) {
      if (!sorts || sorts.length === 0) {
        return KISS_USER.pagination.defaultSort;
      }
      return sorts;
    }

    /**
     *
     */
    function preparBeforeSearch() {
      var clone = new User(this);
      clone.pageCriteria = this.pageCriteria;

      if (clone.role === 'ALL') {
        clone.role = null;
      } else {
        clone.roles = [clone.role];
      }
      if (clone.status === 'ALL') {
        clone.status = null;
      } else {
        clone.status = [clone.status];
      }

      if (this.entity) {
        if (this.entity instanceof PrincipalDetail) {
          clone.principalId = this.entity.id;
        } else if (this.entity.legalEntity) {
          clone.legalEntityId = this.entity.legalEntity.id;
        } else {
          clone.sellerId = this.entity.id;
        }
      }
      return clone;
    }

    /**
     * Indiquer la page
     */
    function setPage(page) {
      this.pageCriteria.page = page;
    }

    /**
     * Changement de pagination
     */
    function setPageSize(pageSize) {
      this.pageCriteria.pageSize = pageSize;
    }

    /**
     * Mise à jour du tri (tri sur une seule colonne)
     */
    function setSort(sorts) {
      this.pageCriteria.sorts = sorts;
    }

    /**
     * Lorsqu'on ne souhaite aucun tri
     */
    function resetSort() {
      this.pageCriteria.sorts = [];
    }
  }
})();
